module.exports = __webpack_public_path__ + "img/Raydium.bce878c8.svg";